import { http } from "../http";

export async function getUserNavigationOptions() {
  try {
    const response = await http({
      method: 'GET',
      url: `${process.env.BFFV2_BASE_URL}/users/navigation/options`,
    });

    if (response.status === 401) {
      window.postMessage({ name: 'iConnectionsEventBus', type: 'logout' }, '*');
    }

    if (response.status === 200 && response && response.data && response.data.success) {
      return { status: true, data: response.data.data };
    }
    return { status: false, error_code: 'RESPONSE_NOT_SUCCESSFUL' };
  } catch (e) {
    console.error(e);
    return { status: false, error_code: 'GENERIC_ERROR' };
  }
}